<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/dHvpXG/tc-custom/9780830889082.jpg?1696642674553" alt="This image is the cover for the book Understanding Postmodernism"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Understanding Postmodernism
      </h1>
      <p class="bookDescription body article font2">
        <p>Postmodernity has matured. But the challenge of navigating our contemporary culture remains. In order for Christians to make wise decisions, we first need to understand the many facets of our postmodern context. If René Descartes is often identified as the first truly modern philosopher in light of his confidence in human reason, then postmodernism has taken Descartes to the woodshed. Stewart Kelly and James Dew detail the litany of concerns that postmodernism has raised: overconfidence in human reason, the limitations of language, the relativity of truth, the lack of a truly objective view, the inherently oppressive nature of metanarratives, the instability of the human self, and the absence any moral superiority. With wisdom and care, Kelly and Dew compare these postmodern principles with the gospel of Jesus Christ and the Christian faith. What emerges is neither a rejection of everything postmodernism is concerned with nor a wholesale embrace of all that it affirms. Instead, we are encouraged to understand the postmodern world as we seek to mature spiritually in Christ.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stewart E. Kelly, James K. Dew Jr.
      </h2>
      
      <p class="authorDescription body article"><p>Stewart E. Kelly (PhD, Notre Dame) is professor of philosophy at Minot State University. He is the author of <em>Truth Considered and Applied</em> and <em>Thinking Well: An Introduction to Critical Thinking</em>.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?757a3ecf